var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-lines block-fullscreen"},[_c('div',{staticClass:"header-logo"},[_c('icon',{attrs:{"name":"td-logo","color":"#393f49"}})],1),_vm._v(" "),_c('section',{staticClass:"block-fullscreen-center"},[_c('questions',{attrs:{"title":"Introdução","items":_vm.questions,"key-form":_vm.keyForm,"prev":"/","next":"/pessoas"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c696350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroForm.vue
// module id = wWYq
// module chunks = 0